export default __webpack_public_path__ + "static/media/faisal.8d084517.png";